
<div class="timer">
    <div class="base-timer">
        <span id="base-timer-label" class="base-timer__label">
      {{ idleTimerLeft }}
    </span>
    </div>
</div>

<!--<div class="modal-container">-->
<!--    <div id="myModal" class="modal">-->
<!--        <div class="modal-content">-->
<!--            <div class="clock-style">-->
<!--                <span>Time Remain -</span>-->
<!--                <span class="time-in-mins">{{ secondTimerLeft }}</span>-->
<!--            </div>-->

<!--            <div style='display: flex;'>-->
<!--                <button (click)='continue()'>Continue</button>-->
<!--                <button (click)='logout()'>Logout</button>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->
